import React from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#f0f0f0' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#4a4a4a' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c0c0c0' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'landscape.man_made', elementType: 'geometry.fill', stylers: [{ color: '#e8e8e8' }] },
    { featureType: 'landscape.natural', elementType: 'geometry.fill', stylers: [{ color: '#eaeaea' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#d4d4d4' }] },
    { featureType: 'road.local', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#b8d8ea' }] },
    { featureType: 'water', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
];

const MAP_OPTIONS = {
    styles: MAP_STYLE,
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    rotateControl: false,
    scaleControl: false,
};

/**
 * use googleMapsApiKey="" in local for dev purposes
 * @param {*} props
 * @returns
 */
function GoogleMapForSiteSupt(props) {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyD7rYafEbst83cps65IrvmUz61n33z4kIM"
    });

    let center = props.center;
    if (isLoaded) {
        const bounds = new window.google.maps.LatLngBounds();
        for (let latlng of props.latlngs)
            if (latlng && latlng.lat && latlng.lng)
                bounds.extend(new window.google.maps.LatLng(latlng.lat, latlng.lng));
        center = bounds.getCenter();
    }

    return isLoaded ?
        <GoogleMap
            mapContainerStyle={props.style}
            center={center}
            zoom={props.zoom}
            options={MAP_OPTIONS}>
            <>
                {props.markers}
                {props.polygons}
            </>
        </GoogleMap> : "";

}

export default GoogleMapForSiteSupt;
